export function formatHtmlForElevenLabs(scriptHtml: string): string {
  const LINE_REGEX = /<p>(.*?)<\/p>/g;
  const lineMatches = [...scriptHtml.matchAll(LINE_REGEX)];

  // Empty or legacy script that doesn't use paragraphs
  if (lineMatches.length === 0) {
    return scriptHtml;
  }

  const AUDIO_TAG_REGEX = /<audio-tag>(.*?)<\/audio-tag>/g;

  return lineMatches
    .filter((lineMatch) => lineMatch[1]!.trim() !== "")
    .map((lineMatch) => lineMatch[1])
    .join("\n")
    .trim()
    .replace(AUDIO_TAG_REGEX, "[$1]")
    .trim();
}
